// Bryn AI symbol: the mascot's brain-cloud head with graduation cap, simplified so it reads at favicon and sidebar sizes.
const COLORS = {
  color: { phone: "#2563FF", cloud: "#D9E7FF", capbase: "#1E43B6", cap: "#2563FF", tassel: "#FFD54F", eye: "#1E43B6", shine: "#FFFFFF" },
  mono: { phone: "currentColor", cloud: "currentColor", capbase: "currentColor", cap: "currentColor", tassel: "currentColor", eye: "#0B0E17", shine: "currentColor" },
};

export function BrynMark({ className = "h-7 w-7", variant = "color", outline = false }) {
  const c = COLORS[variant] || COLORS.color;
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true" focusable="false">
      <rect x="5" y="29" width="9" height="17" rx="4.5" fill={c.phone} />
      <rect x="50" y="29" width="9" height="17" rx="4.5" fill={c.phone} />
      <g fill={c.cloud} stroke={outline ? "#1E43B6" : "none"} strokeWidth={outline ? 1.6 : 0}>
        <circle cx="20" cy="34" r="11" /><circle cx="44" cy="34" r="11" /><circle cx="32" cy="29" r="13" /><ellipse cx="32" cy="42" rx="17" ry="12" />
      </g>
      <path d="M19 19h26v5.5a3 3 0 0 1-3 3H22a3 3 0 0 1-3-3z" fill={c.capbase} />
      <path d="M32 7 57 15.5 32 24 7 15.5z" fill={c.cap} />
      <path d="M32 15.5 51 18v11" fill="none" stroke={c.tassel} strokeWidth="1.8" strokeLinecap="round" />
      <rect x="48.6" y="28" width="4.8" height="7" rx="2.2" fill={c.tassel} />
      <ellipse cx="25.5" cy="38" rx="3.3" ry="4.2" fill={c.eye} /><ellipse cx="38.5" cy="38" rx="3.3" ry="4.2" fill={c.eye} />
      <circle cx="26.6" cy="36.4" r="1.25" fill={c.shine} /><circle cx="39.6" cy="36.4" r="1.25" fill={c.shine} />
      <path d="M28.5 45.2q3.5 3.4 7 0" fill="none" stroke={c.eye} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function BrynLogo({ className = "", markClass = "h-7 w-7", text = "text-base" }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="bryn-logo">
      <BrynMark className={markClass} />
      <span className={`font-display font-semibold tracking-tight ${text}`}>Bryn <span className="text-sky-300">AI</span></span>
    </span>
  );
}
